module.exports = __webpack_public_path__ + "static/gallery_west_street_6-e2c07d555dca64e4eb30a77bbb8968fe.jpg";